<template>
  <div class="commodity_sorting_operation_box">
    <!--头部区域-->
    <div class="scanning_header_box flex justify-content-between align-items-center mb10">
      <h2 class="title">{{ $t('key1004250') }}</h2>
      <Button type="primary" v-if="getPermission('ymsPickupOrder_quitSorting')"
        @click="endSortingOrderBtn('sorting')">{{ $t('key1004229') }}</Button>
    </div>
    <!--内容主体区域-->
    <div class="commodity_sorting_content">
      <!--左边提单区域-->
      <div class="scan_bill_box mr10">
        <!--扫描提单号-->
        <div class="scanning_box mb10">
          <div class="input_styles flex flex-direction">
            <h4 class="title">{{ $t('key1004116') }}</h4>
            <Input
              size="large"
              :disabled="scanBillDisabled"
              :element-id="'scanning'"
              :placeholder="$t('key1004247')"
              @on-enter="enterScanBillInput"
              prefix="icon-scan"
              clearable
              v-model.trim="scanInput">
            </Input>
          </div>
        </div>
        <!--tab栏切换-->
        <div class="table_box pl10 pr10">
          <Tabs v-model="sortTab" :animated="false" @on-click="(name)=>changeTabs(name, 'change')">
            <TabPane v-for="(item, index) in sortTabList" :label="item.name" :name="item.value" :key="index">
            </TabPane>
          </Tabs>
          <ve-table
            v-if="tableData.length >0"
            :max-height="550"
            :borderY="true"
            :columns="tableColumns"
            :table-data="tableData"
            :scrollWidth="400"/>
          <div v-else class="no_classify">
            <img :src="noContent" width="150" height="auto" alt="no content">
            <div class="txt">{{ $t('key1000104') }}</div>
          </div>
        </div>
        <!--结束本单分拣-->
        <div class="end_sort_order_btn">
          <Button style="width: 100%" type="primary" :disabled="!getPermission('ymsPickupOrder_closeSorting') || !scanBillDisabled"
            @click="endSortingOrderBtn('bill')">{{ $t('key1004251') }}</Button>
        </div>
      </div>
      <!--右边sku、容器区域-->
      <div class="scan_sku_box">
        <!--扫描SKU-->
        <div class="flex align-items-center mb10" style="background-color: #fff;">
          <div class="scanning_box mb10">
            <div class="input_styles flex flex-direction" style="width: 400px;">
              <h4 class="title">{{ configCharacters(false) + $t('key1004246') }}</h4>
              <Input
                :disabled="scanSkuDisabled"
                size="large"
                :element-id="'sku_scanning'"
                :placeholder="$t('key1004245')+`${configCharacters(false)}`+$t('key1004246')"
                @on-enter="enterScanSkuInput"
                prefix="icon-scan"
                v-model.trim="scanSkuInput">
              </Input>
            </div>
          </div>
          <Checkbox class="ml10 checkbox_styles" v-if="!extremeDeliveryMode" v-model="isEachPiece" size="large">{{ $t('key1004252') }}</Checkbox>
          <Checkbox class="ml10 checkbox_styles" v-model="overstepTip" size="large">{{ $t('key1004253') }}</Checkbox>
          <Checkbox class="ml10 checkbox_styles" v-model="broadcast" size="large">{{ $t('key1004254') }}</Checkbox>
          <div class="cursor checkbox_styles ml20" style="color: #2D8CF0"
            @click="$refs.scanRecord.initScanRecordData()">{{ $t('key1004164') }}
          </div>
          <!--容器音频-->
          <audio preload="auto" ref="audioDom" v-show="false"></audio>
          <!--贴单音频-->
          <audio preload="auto" ref="audioSticker" @ended="overAudio" v-show="false"></audio>
        </div>
        <div class="scan_content_box mb10" v-if="!exceptionPromptTalg && scanSkuDisabled && Object.keys(scanGoodsInfo).length<=0"></div>
        <div class="scan_content_box mb10 scan_commodity_styles" v-if="exceptionPromptTalg && Object.keys(scanGoodsInfo).length<=0">
          <div class="flex align-items-center">
            <Icon v-if="exceptionPromptIcon" type="ios-close-circle-outline" color="#FF0000" size="33" style="font-weight: bold;"/>
            <h2 class="scan_commodity_title ml10">{{ exceptionPromptText }}</h2>
          </div>
        </div>
        <div class="scan_content_box mb10" v-if="Object.keys(scanGoodsInfo).length>0">
          <!--物流面单：LOGIS_LABEL， 云卖面单：YMS_LABEL  无面单：NONE_LABEL-->
          <div class="flex align-items-center">
            <h3 v-if="changeLabel" class="sticker_tips_style">{{ $t('key1004255') }}</h3>
            <h2 class="face_sheet_style" :style="{backgroundColor: scanGoodsInfo.colorCode}">{{ scanGoodsInfo.labelTypeName }}</h2>
          </div>
          <div class="scan_center_box">
            <Tooltip placement="right" theme="light" :transfer="true" transfer-class-name="set_bigimg_style"
              v-if="scanGoodsInfo.containerType !== 'LOGIS_LABEL'">
              <img class="img_styles" :src="setImgPath(scanGoodsInfo.primaryImage, null, '70x70')" @error="setErrorImg($event)" alt=""/>
              <template #content>
                <img class="big_img_styles" :src="setImgPath(scanGoodsInfo.primaryImage)" @error="setErrorImg($event)" alt=""/>
              </template>
            </Tooltip>
            <div class="text_style_box" v-if="scanGoodsInfo.containerType === 'LOGIS_LABEL'">
              <p class="text_styles">{{ `${configCharacters()}` + $t('key1004249') + scanGoodsInfo.packageCode }}</p>
              <p class="text_styles">{{ $t('key1001521') + scanGoodsInfo.trackingNumber }}</p>
            </div>
            <div class="text_style_box" v-else>
              <p class="text_styles" v-if="ymsSkuKeyList.includes(scanGoodsInfo.containerType)">{{ $t('key1001103') + scanGoodsInfo.ymsSku }}</p>
              <p class="text_styles" v-if="supplierSkuKeyList.includes(scanGoodsInfo.containerType)">{{ $t('key1001103') + scanGoodsInfo.supplierSku }}</p>
              <p class="text_styles">{{ $t('key1000100') + scanGoodsInfo.title }}</p>
            </div>
          </div>
        </div>
        <!--容器区域-->
        <div class="container_boxs">
          <div v-for="(item, index) in containerList" :key="index" class="container_box_item" @click="selectContainer(item, index)">
            <h2 class="container_box_title" :style="{color: item.colorCode ? item.colorCode : ''}">{{ item.labelTypeName }}</h2>
            <div class="flex align-items-center justify-content-between pl10 pr10 ptb10 border-bottom" style="margin-bottom: 6px;">
              <div class="input_styles flex align-items-center">
                <p class="title ml10" style="width: 65px;">{{ $t('key1002400') }}</p>
                <Input
                  style="width: 200px;"
                  :disabled="item.disabled"
                  :element-id="'scanning_' + index"
                  :placeholder="$t('key1004071')"
                  @on-enter="enterScanContainer(item, index)"
                  prefix="icon-scan"
                  v-model.trim="item.code">
                </Input>
              </div>
            </div>
            <!--请添加容器的遮罩层-->
            <div class="add_container_styles" v-if="item.tableData.length<=0 && currentIndex === index">{{ $t('key1004256') }}</div>
            <div class="pl10 pr10 add_container_item">
              <Table
                v-if="item.tableData.length>0 && currentIndex !== index"
                highlight-row
                border
                max-height="200"
                :loading="tableLoading"
                :columns="item.tableColumns"
                :data="item.tableData">
              </Table>
            </div>
            <div class="options_box">
              <Button style="width: 100%;" type="primary"
                :disabled="!(item.tableData.length>0 && getPermission('ymsContainerStatus_closeContainerSorting'))"
                @click.stop="containerPickingBtn(item)">{{ $t('key1004257') }}</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--SKU扫描异常提示-匹配到多种类型面单-->
    <Modal v-model="scanAbnormalModal" width="400" :mask-closable="false" :closable="false">
      <h2 class="flex mb10 align-items-center">
        <Icon size="26" type="ios-alert" color="#f90"></Icon>
        <span class="font-weight-bold ml10" style="font-size: 17px; color:#333;">{{ $t('key1004258') }}</span>
      </h2>
      <RadioGroup v-model="labelTypeRadioId" class="pl20">
        <Radio v-for="(item, index) in labelTypeRadioList" :key="index" :label="item.containerType">{{ item.name }}</Radio>
      </RadioGroup>
      <template #footer>
        <div style="text-align: center;">
          <Button type="primary" @click="scanAbnormalBtn">{{ $t('key1000111') }}</Button>
        </div>
      </template>
    </Modal>
    <!--打印预览YMS面单弹窗-->
    <printPreviewWaybillModal ref="printPreviewWaybill" :printUrl="apiUrl"></printPreviewWaybillModal>
    <!--扫描云卖SKU/供应商SKU/物流面单，超出应发数量的提示框-->
    <Modal v-model="scanningSkuModal" :title="scanningSkuTitle" width="550" :transfer="false" :mask-closable="false"
      class-name="scanningSkuModalStyle" @on-visible-change="scanningSkuModalChange">
      <Alert type="warning" show-icon style="padding: 8px 35px;"> {{ alertText }}</Alert>
      <div class="table_box" v-if="scanningSkuTableData.length >0">
        <Table
          highlight-row
          border
          max-height="300"
          :loading="tableLoading"
          :columns="scanningSkuTableColumns"
          :data="scanningSkuTableData">
        </Table>
      </div>
      <div class="table_box mt20" v-if="scanningOrderTableData.length >0">
        <Table
          highlight-row
          border
          max-height="300"
          :loading="tableLoading"
          :columns="scanningOrderTableColumns"
          :data="scanningOrderTableData">
        </Table>
      </div>
      <!--扫描添加上架容器-->
      <div class="shelving_container_box" v-if="bingShelfTalg">
        <h2 class="title_box">{{ shelvingContainerText }}</h2>
        <Input
          style="width: 300px;"
          :placeholder="$t('key1004248')"
          prefix="icon-scan"
          v-model.trim="shelvingContainerCode">
        </Input>
      </div>
      <template #footer>
        <div style="text-align: right;" v-if="scanningSkuType === 'scanning'">
          <Button v-if="bingShelfTalg" @click="scanningSkuModal = false">{{ $t('key1004259') }}</Button>
          <Button v-if="bingShelfTalg" type="primary" @click="shelvingContainer">{{ $t('key1004260') }}</Button>
          <Button v-else type="primary" @click="scanningSkuModal = false">{{ $t('key1000316') }}</Button>
        </div>
        <div style="text-align: right;" v-else>
          <Button @click="scanningSkuModal = false">{{ $t('key1001251') }}</Button>
          <Button type="primary" @click="endSortBtn">{{ $t('key1004231') }}</Button>
        </div>
      </template>
    </Modal>
    <!--扫描记录弹窗-->
    <scanRecordModal
      ref="scanRecord"
      @updateData="undoUpdateData"
      :ymsPickupOrderId="ymsPickupOrderId"
      :originalContainerList="originalContainerList">
    </scanRecordModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';


import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import scanRecordModal from "@/views/yms/components/collectionManage/scanRecordModal.vue";
import {setConfigCharacters} from "@/utils/common";
import printPreviewWaybillModal from "@/components/common/printPreviewWaybillModal.vue";

export default {
  name: "commoditySortingOperation",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      scanInput: '', // 提单号
      scanSkuInput: '', // 云卖SKU/供应商SKU/物流面单
      sortTab: 'sku', // sku  order
      sortTabList: [
        {name: 'SKU', value: 'sku'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887'), value: 'order'}
      ],
      skuTableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000585'),
          key: 'primaryImage',
          width: 120,
          align: 'center',
          renderBodyCell({row, column, rowIndex}, h) {
            let params = {
              row: row
            };
            return v.tableImg(h, params, 'primaryImage');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000307'),
          width: 160,
          key: 'specifications',
          align: 'center',
          renderBodyCell({row, column, rowIndex}, h) {
            let specifications = row.specifications || [];
            if (specifications.length > 0) {
              return h('div', row.specifications.map(item => {
                return h('p', [
                  h('span', item.name + '：'),
                  h('span', item.value)
                ]);
              }));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
          key: 'supplierSku',
          width: 120,
          align: 'center',
          renderBodyCell({row, column, rowIndex}, h) {
            return h('p', {
              style: {
                wordWrap: 'break-word',
                wordBreak: 'break-all'
              }
            }, row.supplierSku);
          }
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          width: 120,
          align: 'center',
          renderBodyCell({row, column, rowIndex}, h) {
            return h('p', {
              style: {
                wordWrap: 'break-word',
                wordBreak: 'break-all'
              }
            }, row.ymsSku);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004215'),
          key: 'allQuantity',
          field: 'allQuantity',
          width: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004216'),
          key: 'sortingQuantity',
          field: 'sortingQuantity',
          width: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004217'),
          width: 110,
          key: 'quantity',
          align: 'center',
          renderBodyCell({row, column, rowIndex}, h) {
            let text = '';
            let quantity = (row.allQuantity - row.sortingQuantity) || '';
            if (row.sortingQuantity >= row.allQuantity) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002554');
            } else {
              text = quantity;
            }
            return h('span', {
              style: {
                color: row.sortingQuantity >= row.allQuantity ? '#52C41A' : ''
              }
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 100,
          fixed: 'right',
          renderBodyCell({row, column, rowIndex}, h) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003537'),
                    show: v.getPermission('ymsPickupOrderDetail_appendYmsExpressBill'),
                    clickFn: () => {
                      v.$refs['printPreviewWaybill'].initPrintPreviewWaybillData(row);
                    }
                  }
                ]
              }
            });
          }
        }
      ], // sku列表
      skuTableData: [],
      orderTableColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'packageCode',
          field: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          field: 'trackingNumber',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003991'),
          key: 'quantity',
          align: 'center',
          renderBodyCell({row, column, rowIndex}, h) {
            let isScanning = row.isScanning === 1;
            let text = '';
            if (isScanning) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002554');
            } else {
              text = row.quantity;
            }
            return h('span', {
              style: {
                color: isScanning ? '#52C41A' : ''
              }
            }, text);
          }
        }
      ], // 订单列表
      orderTableData: [],
      tableColumns: [],
      tableData: [],
      isEachPiece: true, // 逐件扫描
      broadcast: true, // 开启语音播报
      originalContainerList: [
        /**(原来的面单类型对应的容器类型)
         * 出库容器:LOGIS_LABEL
         * 上架容器:YMS_LABEL
         * 贴单+上架容器：NONE_LABEL
         */

        /** JIT流程的所有容器类型
         * 拣货容器 PICKING_LABEL
         * 贴单+上架容器 CHANGE_SHELVE_LABEL
         * 贴单+拣货容器 CHANGE_PICKING_LABEL
         * 贴单+包装容器 CHANGE_PACKING_LABEL
         * 上架容器 SHELVE_LABEL
         * 包装容器 PACKING_LABEL
         */

        {
          code: '',
          containerType: 'YMS_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002656'),
          disabled: false,
          tableColumns: [
            {
              title: `${setConfigCharacters(false)}SKU`,
              key: 'ymsSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 上架容器(云卖面单) YMS_LABEL
        {
          code: '',
          containerType: 'LOGIS_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002658'),
          disabled: false,
          tableColumns: [
            {
              title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
              key: 'packageCode',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
              key: 'trackingNumber',
              align: 'center',
            },
          ],
          tableData: []
        }, // 出库容器(物流面单) LOGIS_LABEL
        {
          code: '',
          containerType: 'NONE_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002657'),
          disabled: false,
          tableColumns: [
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
              key: 'supplierSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 贴单+上架容器(无面单) NONE_LABEL
        {
          code: '',
          containerType: 'PICKING_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002661'),
          disabled: false,
          tableColumns: [
            {
              title: `${setConfigCharacters(false)}SKU`,
              key: 'ymsSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 拣货容器
        {
          code: '',
          containerType: 'CHANGE_SHELVE_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002657'),
          disabled: false,
          tableColumns: [
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
              key: 'supplierSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 贴单+上架容器
        {
          code: '',
          containerType: 'CHANGE_PICKING_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002662'),
          disabled: false,
          tableColumns: [
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
              key: 'supplierSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 贴单+拣货容器
        {
          code: '',
          containerType: 'CHANGE_PACKING_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002660'),
          disabled: false,
          tableColumns: [
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000586'),
              key: 'supplierSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 贴单+包装容器
        {
          code: '',
          containerType: 'SHELVE_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002656'),
          disabled: false,
          tableColumns: [
            {
              title: `${setConfigCharacters(false)}SKU`,
              key: 'ymsSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 上架容器
        {
          code: '',
          containerType: 'PACKING_LABEL',
          labelTypeName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002659'),
          disabled: false,
          tableColumns: [
            {
              title: `${setConfigCharacters(false)}SKU`,
              key: 'ymsSku',
              align: 'center'
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004218'),
              key: 'quantity',
              align: 'center'
            },
          ],
          tableData: []
        }, // 包装容器
      ], // 容器列表的原始数据
      ymsSkuKeyList: ['PICKING_LABEL', 'SHELVE_LABEL', 'PACKING_LABEL', 'YMS_LABEL'], // 列表展示云卖sku的容器类型
      supplierSkuKeyList: ['CHANGE_SHELVE_LABEL', 'CHANGE_PICKING_LABEL', 'CHANGE_PACKING_LABEL'], //  列表展示供应商sku的容器类型
      containerList: [], //容器列表
      currentIndex: 0,
      scanBillDisabled: true, // 禁用扫描提单号输入框
      scanSkuDisabled: true, // 禁用扫描云卖SKU/供应商SKU/物流面单输入框
      containerTypes: [], // 当前提单所需容器类型
      ymsWarehouseId: null,
      bindContainerList: [], // 未绑定的容器
      bindingContainerList: [], // 绑定的容器
      ymsPickupOrderId: null,
      scanAbnormalModal: false,
      labelTypeRadioList: [], // 扫描sku到多个面单类型
      labelTypeRadioId: null,
      exceptionPromptTalg: false, // 添加商品、扫描sku匹配不到商品的提示变量
      exceptionPromptText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004219'),
      exceptionPromptIcon: false,
      containerIndex: 0,
      scanGoodsInfo: {}, // 获取扫描货品的基本信息
      overstepTip: true, // 超出应发数量是否提示
      allProductInfoList: [],
      apiUrl: api.post_ymsPickupOrderDetail_appendYmsExpressBill,
      scanningSkuModal: false,
      scanningSkuTableData: [],
      scanningSkuTableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 180,
          render(h, params) {
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, 'primaryImage'),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.title),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row.ymsSku),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004215'),
          key: 'allQuantity',
          align: 'center',
          width: 110
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004220'),
          key: 'sortingQuantity',
          align: 'center',
          width: 110
        },
      ],
      scanningOrderTableData: [],
      scanningOrderTableColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'packageCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'trackingNumber',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'isScanning',
          align: 'center',
          render(h, params) {
            let text = params.row.isScanning === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004221') : '';
            return h('span', text);
          }
        }
      ],
      alertText: '',
      scanningSkuType: null,
      endType: null,
      scanningSkuTitle: '',
      extremeDeliveryMode: 0, // 极速出库模式
      sortingStickerType: null, // 记录绑定上架容器 还是 贴单+上架容器
      bingShelfTalg: false, // 是否需要绑定上架容器
      shelvingContainerText: '',
      shelvingContainerCode: '',
      stickerAudio: require('@/assets/images/stickerAudio.mp3'), // 贴单音频
      containerAudio: null,
      scanningGoodsObj: {},
      changeLabel: false, // 是否标识贴单
      originalSkuInput: '',
      noContent: require('@/assets/images/noContent.gif'),
    };
  },
  created() {
    this.getSupplierPickupOrderData('', 'created');
  },
  methods: {
    // 获取扫描的提货单号数据
    getSupplierPickupOrderData(scanInput, type) {
      let v = this;
      let ymsProductGoodsIds = [];
      let selectTab = '';
      let supplierPickupOrderNumber = scanInput ? scanInput : v.$route.query.supplierPickupOrderNumber;
      if (supplierPickupOrderNumber) {
        v.axios.put(api.put_ymsPickupOrder_startSorting + `?businessId=${supplierPickupOrderNumber}`,
          null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.scanBillDisabled = true;
            v.scanInput = data.supplierPickupOrderNumber;
            v.$router.push({
              path: v.$route.path,
              query: {
                ...v.$route.query,
                supplierPickupOrderNumber: data.supplierPickupOrderNumber
              }
            });
            if (data) {
              v.ymsWarehouseId = data.ymsWarehouseId;
              v.ymsPickupOrderId = data.ymsPickupOrderId;
              if (data.code === 111226) {
                let containerType = data.message;
                v.originalContainerList.map((item) => {
                  if (item.containerType === containerType) {
                    let labelTypeName = item.labelTypeName;
                    let text = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004211')}${labelTypeName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004212')}${labelTypeName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004213')}`;
                    v.$Message.warning(text);
                    v.scanBillDisabled = false;
                    v.scanInput = '';
                    v.scanSkuDisabled = true;
                  }
                });
                v.getContainerList();
              } else {
                v.getConfigurationData(v.ymsWarehouseId);
                v.containerTypes = data.containerTypes || [];
                // 匹配当前提单中需要哪些容器
                let containerList = [];
                if (v.containerTypes.length > 0) {
                  v.originalContainerList.map((item) => {
                    if (v.containerTypes.includes(item.containerType)) {
                      containerList.push(item);
                    }
                  });
                  v.bindContainerList = v.uniqueFunc(containerList, 'containerType');
                  v.getContainerList();
                }
                if (type !== 'update') {
                  // sku列表
                  (async () => {
                    let pickupOrderSortingSkuList = data.pickupOrderSortingSkuBos || [];
                    // 根据ymsProductGoodsId 相同聚合累加 allQuantity 和 sortingQuantity，并去重
                    let new_arr = pickupOrderSortingSkuList.reduce((acc, curr) => {
                      const existingItem = acc.find(item => item.ymsProductGoodsId === curr.ymsProductGoodsId);
                      if (existingItem) {
                        existingItem.allQuantity += curr.allQuantity;
                        existingItem.sortingQuantity += curr.sortingQuantity;
                      } else {
                        acc.push({
                          ymsProductGoodsId: curr.ymsProductGoodsId,
                          allQuantity: curr.allQuantity,
                          sortingQuantity: curr.sortingQuantity,
                          pickingTime: curr.pickingTime
                        });
                      }
                      return acc;
                    }, []);
                    if (new_arr.length > 0) {
                      selectTab = 'sku';
                      if (v.tableData && v.tableData.length) {
                        // 如果已经有值了
                        v.tableData.forEach((i, index) => {
                          new_arr.forEach(j => {
                            if (i.ymsProductGoodsId === j.ymsProductGoodsId) {
                              v.$set(v.tableData[index], 'sortingQuantity', j.sortingQuantity);
                            }
                          });
                        });
                        v.skuTableData.forEach((i, index) => {
                          new_arr.forEach(j => {
                            if (i.ymsProductGoodsId === j.ymsProductGoodsId) {
                              v.$set(v.skuTableData[index], 'sortingQuantity', j.sortingQuantity);
                            }
                          });
                        });
                      } else {
                        new_arr.map((ele) => {
                          ymsProductGoodsIds.push(ele.ymsProductGoodsId);
                        });
                        if (ymsProductGoodsIds.length > 0) {
                          v.allProductInfoList = await v.getProductInfoByIds(ymsProductGoodsIds, [], false, true);
                          let list = v.getProductInfoByOriginal(new_arr);

                          if (list) {
                            let _list = list.map((item) => {
                              item.ymsSku = '';
                              item.supplierSku = '';
                              item.specifications = [];
                              if (item._productInfo) {
                                let primaryImage = item._productInfo._spuInfo.primaryImage;
                                item.ymsSku = item._productInfo.ymsSku;
                                item.supplierSku = item._productInfo.supplierSku;
                                item.primaryImage = item._productInfo.primaryImage || primaryImage;
                                item.title = item._productInfo._spuInfo.name;
                                let specificationList = item._productInfo.productGoodsSpecificationList;
                                if (specificationList && specificationList.length > 0) {
                                  specificationList.map((ele) => {
                                    item.specifications.push({
                                      name: ele.name,
                                      value: ele.value
                                    });
                                  });
                                }
                              }
                              let obj = {
                                primaryImage: item.primaryImage || item._productInfo._spuInfo.primaryImage,
                                specifications: item.specifications,
                                supplierSku: item.supplierSku,
                                ymsSku: item.ymsSku,
                                cnName: item._productInfo._spuInfo.name,
                                ymsProductGoodsId: item._productInfo.ymsProductGoodsId,
                                allQuantity: item.allQuantity,
                                sortingQuantity: item.sortingQuantity,
                                _productInfo: item._productInfo
                              };
                              return obj;
                            });
                            v.$nextTick(() => {
                              v.tableData = _list;
                              v.skuTableData = list;
                              v.changeTabs(selectTab, 'change');
                              v.$forceUpdate();
                            });
                          }
                        } else {
                          v.$nextTick(() => {
                            v.tableData = new_arr;
                            v.skuTableData = new_arr;
                            v.changeTabs(selectTab, 'change');
                            v.$forceUpdate();
                          });
                        }
                      }
                    }
                    v.stickerOperation(v.skuTableData, v.originalSkuInput);
                    v.scanSkuInput = '';
                  })();
                  // 订单列表
                  if (data.pickupOrderSortingPackageBos.length > 0) {
                    selectTab = 'order';
                    data.pickupOrderSortingPackageBos.map((talg) => {
                      talg.quantity = 1;
                    });
                    v.$nextTick(() => {
                      v.tableData = data.pickupOrderSortingPackageBos;
                      v.orderTableData = data.pickupOrderSortingPackageBos;
                      v.changeTabs(selectTab, 'change');
                      v.$forceUpdate();
                    });
                  }
                  if ((!data.pickupOrderSortingPackageBos || data.pickupOrderSortingPackageBos.length === 0) &&
                    (!data.pickupOrderSortingSkuBos || data.pickupOrderSortingSkuBos.length === 0)) {
                    v.tableData = [];
                    v.orderTableData = [];
                  }
                  v.getContainerList();
                }
              }
            }
          }
        });
      } else {
        v.scanBillDisabled = false;
        v.$nextTick(() => {
          v.getFocus('scanning');
        });
        v.changeTabs('sku');
        v.getContainerList();
      }
    },

    getProductInfoByOriginal(originalData, isGetSpu) {
      let copyData = JSON.parse(JSON.stringify(originalData));
      let v = this;
      if (v.typeOf(copyData) === 'object') {
        copyData.data.forEach(ch => {
          let child = ch;
          copyData.childKey.forEach(param => {
            child = child[param];
          });
          child.forEach((i) => {
            v.allProductInfoList.forEach(j => {
              j.ymsProductGoodsList.forEach(k => {
                if (i.ymsProductGoodsId === k.ymsProductGoodsId) {
                  if (isGetSpu) {
                    i._productInfo = j;
                  } else {
                    let obj = JSON.parse(JSON.stringify(j));
                    i._productInfo = {
                      ...k,
                      _spuInfo: obj
                    };
                  }
                }
              });
            });
          });
        });
        copyData = copyData.data;
      } else {
        if (copyData) {
          if (v.allProductInfoList) {
            copyData.forEach((i, index) => {
              v.allProductInfoList.forEach(j => {
                j.ymsProductGoodsList.forEach(k => {
                  if (i.ymsProductGoodsId === k.ymsProductGoodsId) {
                    if (isGetSpu) {
                      copyData[index]._productInfo = j;
                    } else {
                      let obj = JSON.parse(JSON.stringify(j));
                      copyData[index]._productInfo = {
                        ...k,
                        _spuInfo: obj
                      };
                    }
                  }
                });
              });
            });
          } else {
            return copyData;
          }
        }
      }
      return copyData;
    },
    // 获取正在分拣中容器列表数据
    getContainerList(type) {
      let v = this;
      let containerType = null;
      let ymsProductGoodsIds = [];
      v.axios.get(api.get_ymsContainerStatus_querySortingContainerList + `?containerType=${containerType}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.originalContainerList.map((item) => {
              data.map((ele) => {
                if (item.containerType === ele.containerType) {
                  item.code = ele.code;
                  item.ymsContainerStatusId = ele.ymsContainerStatusId;
                  item.disabled = !!item.code;
                  item.colorCode = ele.colorCode;
                  item.colorAudioPath = ele.colorAudioPath;
                  v.bindingContainerList.push(item);
                }
              });
            });
            let list = [...v.bindContainerList, ...v.bindingContainerList];
            v.containerList = v.uniqueFunc(list, 'containerType');
            if (v.containerList.length > 0) {
              v.currentIndex = null;
              v.exceptionPromptTalg = v.containerList.every((item) => {
                return item.code !== '';
              });
              for (let i = 0; i < v.containerList.length; i++) {
                let item = v.containerList[i];
                if (item.code === '') {
                  v.currentIndex = i;
                  break;
                }
              }
              (async () => {
                let new_arr = [];
                data.map((item) => {
                  if (item.ymsPickupOrderSortingList) {
                    item.ymsPickupOrderSortingList.map((ele) => {
                      new_arr.push(ele);
                    });
                  }
                });
                if (new_arr.length > 0) {
                  new_arr.map((ele) => {
                    ele.ymsProductGoodsId = ele.businessId;
                    ymsProductGoodsIds.push(ele.ymsProductGoodsId);
                  });
                  if (ymsProductGoodsIds.length > 0) {
                    (async () => {
                      v.allProductInfoList = await v.getProductInfoByIds(ymsProductGoodsIds, [], false, true);
                      let list = v.getProductInfoByOriginal(new_arr);
                      if (list) {
                        v.containerList.map((item, index) => {
                          let listData = [];
                          list.map((ele) => {
                            if (item.ymsContainerStatusId === ele.ymsContainerStatusId) {
                              if (ele._productInfo) {
                                ele.ymsSku = ele._productInfo.ymsSku;
                                ele.supplierSku = ele._productInfo.supplierSku;
                              }
                              if (ele.extendJson) {
                                let obj = JSON.parse(ele.extendJson);
                                ele = Object.assign({}, ele, obj);
                              }
                              listData.push(ele);
                              let obj = v.uniqueFunc(listData, 'businessId');
                              v.$set(v.containerList[index], 'tableData', obj);
                              v.$forceUpdate();
                            }
                          });
                        });
                        // 更新数据
                        if (type !== 'update') {
                          if (v.exceptionPromptTalg) {
                            v.exceptionPromptIcon = false;
                            v.exceptionPromptText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004219');
                          }
                        }
                      }
                    })();
                  }
                }
              })();
              v.positionCursor(v.containerList);
              v.$forceUpdate();
            }
          }
        }
      });
    },

    // 回车键扫描提货单号
    enterScanBillInput() {
      let v = this;
      if (v.scanInput) {
        v.getSupplierPickupOrderData(v.scanInput);
        v.$router.push({
          path: '/commoditySortingOperation',
          query: {
            supplierPickupOrderNumber: v.scanInput
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004222'));
        return false;
      }
    },

    // 回车键扫描云卖SKU/供应商SKU/物流面单
    enterScanSkuInput() {
      let v = this;
      // 先调扫描匹配货品接口， 在调扫描货品到容器
      if (v.scanSkuInput) {
        let obj = {
          code: v.scanSkuInput,
          ymsPickupOrderId: v.ymsPickupOrderId
        };
        v.originalSkuInput = obj.code;
        v.scanSkuDisabled = true;
        v.sortingStickerType = null;
        let talg = true;
        // 校验物流面单不能重复扫
        if (v.orderTableData.length > 0) {
          v.orderTableData.map((item) => {
            if (item.trackingNumber === v.scanSkuInput) {
              if (item.isScanning === 1) {
                talg = false;
              }
            }
          });
        }
        if (talg) {
          v.axios.post(api.post_ymsPickupOrder_scanningGoods, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            let code = response.data.code;
            if (code === 0) {
              let data = response.data.datas;
              if (data && data.length > 0) {
                if (data.length > 1) {
                  /** 扫描sku匹配到多个容器时，在开启极速出库模式情况下按照优先级：包装容器 > 拣货容器 > 上架容器 匹配容器
                   * 扫描sku匹配到多个容器时，没有极速出库模式情况下，弹出弹窗让用户手动选择对应的容器
                   */
                  if (v.extremeDeliveryMode) {
                    for (let i = 0; i < data.length; i++) {
                      let item = data[i];
                      item.ymsProductGoodsId = item.businessId;
                      if (item.containerType === 'PACKING_LABEL') {
                        v.scanGoodsData(item, 'sku');
                        return false;
                      } else if (item.containerType === 'PICKING_LABEL') {
                        v.scanGoodsData(item, 'sku');
                        return false;
                      } else if (item.containerType === 'SHELVE_LABEL') {
                        v.scanGoodsData(item, 'sku');
                        return false;
                      }
                    }
                  } else {
                    let arr = [
                      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002656'), value: 'YMS_LABEL'},
                      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002658'), value: 'LOGIS_LABEL'},
                      {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002657'), value: 'NONE_LABEL'}
                    ];
                    data.map((item) => {
                      arr.map((ele) => {
                        if (ele.value === item.containerType) {
                          item.name = ele.name;
                        }
                      });
                    });
                    v.labelTypeRadioList = data;
                    v.scanAbnormalModal = true;
                    v.labelTypeRadioId = null;
                  }
                } else {
                  let billType = '';
                  data[0].ymsProductGoodsId = data[0].businessId;
                  if (data[0].containerType === 'LOGIS_LABEL') {
                    billType = 'order';
                  } else {
                    billType = 'sku';
                  }
                  if (data[0]) {
                    if (data[0].ymsContainerStatusId) {
                      v.changeTabs(billType);
                      v.scanGoodsData(data[0], billType);
                      v.getSkuInfo([data[0].businessId], data[0].containerType, data);
                    } else {
                      // 未找到上架容器，需要绑定上架容器
                      if (v.overstepTip) {
                        v.sortingStickerType = data[0].containerTynullpe;
                        v.scanSkuDisabled = false;
                        v.skuTableData.map((item) => {
                          if (item.ymsSku === v.scanSkuInput || item.supplierSku === v.scanSkuInput) {
                            item.sortingQuantity += 1;
                            if (item.sortingQuantity > item.allQuantity) {
                              v.handleScanningSkuData('scanning', item);
                            } else {
                              let containerList = [];
                              v.originalContainerList.map((item) => {
                                if (item.containerType === v.sortingStickerType) {
                                  containerList.push(item);
                                }
                              });
                              if (containerList.length > 0) {
                                let nameList = containerList.map((ele) => {
                                  return ele.labelTypeName;
                                });
                                v.$Modal.confirm({
                                  title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
                                  content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004223') + nameList.join('、'),
                                  okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
                                  onOk: () => {
                                    let arr = [...v.containerList, ...containerList];
                                    v.containerList = v.uniqueFunc(arr, 'containerType');
                                    setTimeout(() => {
                                      const index = v.containerList.findIndex(item => item.tableData.length <= 0 && item.code === '');
                                      v.selectContainer(v.containerList[index], index);
                                    }, 800);
                                  }
                                });
                              }
                            }
                          }
                        });
                      }
                    }
                  }
                }
              } else {
                v.exceptionPromptTalg = true;
                v.scanGoodsInfo = {};
                v.exceptionPromptText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004224');
                v.exceptionPromptIcon = true;
                v.scanSkuDisabled = false;
              }
            } else {
              v.scanSkuDisabled = false;
              // 提单中存在有已经取消订单的sku，需要走上架容器，后台会返回需要的上架容器，前端需要重新更新当前扫描提单详情的数据
              if (code === 111216) {
                v.getSupplierPickupOrderData('', 'update');
              }
            }
          });
        } else {
          v.scanSkuDisabled = false;
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004225'));
          return false;
        }
      } else {
        v.$Message.warning(`${setConfigCharacters(false)}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004214')}`);
        return false;
      }
    },

    // 描货品到容器
    scanGoodsData(data, billType) {
      let v = this;
      let query = {
        batchInsert: v.isEachPiece ? 0 : 1, // 逐件扫描 0 是， 1否
        businessId: data.businessId,
        ymsContainerStatusId: data.ymsContainerStatusId,
        ymsPickupOrderId: data.ymsPickupOrderId,
        fastDeliveryStatus: data.fastDeliveryStatus,
        ymsPackageId: data.ymsPackageId,
        ymsPickupOrderDetailId: data.ymsPickupOrderDetailId
      };
      v.axios.post(api.post_ymsPickupOrderSorting_saveScanningGoods, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        v.scanSkuDisabled = false;
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.scanningGoodsObj = data;
          // 扫描sku、运单号先落地在前端，在刷新页面的时候在调接口更新提单中分拣数量
          v.updateScanInfoData(data, billType);
          v.getContainerList('update');
          v.scanAbnormalModal = false;
          v.playAudio(data);
        } else {
          let code = response.data.code;
          let abnormalCodeList = [
            {code: 1112697, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004226'), content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004227')},
            {code: 1112698, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004226'), content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004228')},
          ];
          for (let i = 0; i < abnormalCodeList.length; i++) {
            let item = abnormalCodeList[i];
            if (code === item.code) {
              v.$Modal.warning({
                title: item.title,
                content: item.content,
                okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
                onOk: () => {
                  v.containerPickingBtn(data);
                },
              });
              return false;
            }
          }
        }
      });
    },

    // 扫描sku、运单号成功时，前端手动更新分拣数量\分拣状态
    updateScanInfoData(data, billType) {
      let v = this;
      if (data) {
        if (v.tableData.length > 0) {
          v.tableData.map((item, index) => {
            // 物流面单
            if (data.containerType === 'LOGIS_LABEL') {
              let obj = JSON.parse(data.extendJson);
              data.packageCode = obj.packageCode;
              data.trackingNumber = obj.trackingNumber;
              if (item.trackingNumber === data.trackingNumber) {
                if (v.orderTableData.length > 0) {
                  v.$set(v.tableData[index], 'isScanning', 1);
                  v.$set(v.orderTableData[index], 'isScanning', 1);
                  setTimeout(() => {
                    v.changeTabs(billType);
                  }, 100);
                }
              }
            } else {
              if (item.ymsProductGoodsId === data.businessId) {
                if (v.skuTableData.length > 0) {
                  // 需要判断当前是否逐件扫描
                  if (v.isEachPiece) {
                    if (billType === 'sku') {
                      let quantity = item.sortingQuantity + 1;
                      v.$set(v.tableData[index], 'sortingQuantity', quantity);
                      v.$set(v.skuTableData[index], 'sortingQuantity', quantity);
                      setTimeout(() => {
                        v.changeTabs(billType);
                      }, 100);
                    }
                  } else {
                    if (billType === 'sku') {
                      let quantity = item.allQuantity - item.sortingQuantity; // 还需分拣数量
                      let sortingQuantity = item.sortingQuantity + quantity;
                      if (item.sortingQuantity < item.allQuantity) {
                        v.$set(v.tableData[index], 'sortingQuantity', sortingQuantity);
                        v.$set(v.skuTableData[index], 'sortingQuantity', sortingQuantity);
                        setTimeout(() => {
                          v.changeTabs(billType);
                        }, 100);
                      }
                    }
                  }
                }
              }
            }
          });
          // 校验当前扫描sku的数量是否大于应发数量
          if (v.overstepTip) {
            setTimeout(() => {
              v.tableData.map((item) => {
                if (item.ymsSku === v.scanSkuInput || item.supplierSku === v.scanSkuInput) {
                  if (item.sortingQuantity > item.allQuantity) {
                    v.handleScanningSkuData('scanning', item);
                  }
                }
              });
              v.scanSkuInput = '';
            }, 300);
          } else {
            v.scanSkuInput = '';
          }
          v.$forceUpdate();
        }
      }
    },

    // 获取扫描sku的基本信息
    getSkuInfo(ymsProductGoodsIds, containerType, data) {
      let v = this;
      if (Object.keys(v.scanGoodsInfo).length > 0) {
        v.exceptionPromptTalg = false;
        v.exceptionPromptText = '';
        v.exceptionPromptIcon = false;
      }
      v.scanGoodsInfo = {};
      let extendJson = {};
      let obj = {};
      let arr = [];
      if (data && data.length > 0) {
        data.map((item) => {
          v.tableData.map((ele) => {
            // 物流面单
            if (item.containerType === 'LOGIS_LABEL') {
              let obj = JSON.parse(item.extendJson);
              item.packageCode = obj.packageCode;
              item.trackingNumber = obj.trackingNumber;
              if (ele.trackingNumber === item.trackingNumber) {
                arr = [item];
              }
            } else {
              if (item.businessId === ele.ymsProductGoodsId) {
                item._productInfo = ele._productInfo;
                arr = [item];
              }
            }
          });
        });
        if (arr && arr.length > 0) {
          let labelTypeObj = {
            LOGIS_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002658'),
            YMS_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002656'),
            NONE_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002657'),
            PICKING_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002661'),
            CHANGE_SHELVE_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002657'),
            CHANGE_PICKING_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002662'),
            CHANGE_PACKING_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002660'),
            SHELVE_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002656'),
            PACKING_LABEL: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002659')
          };
          arr.map((item) => {
            if (item.containerType === containerType) {
              // 物流面单
              if (containerType === 'LOGIS_LABEL') {
                if (item.extendJson) {
                  extendJson = JSON.parse(item.extendJson);
                  obj = {
                    labelTypeName: labelTypeObj[containerType],
                    containerType: item.containerType
                  };
                  v.scanGoodsInfo = Object.assign({}, obj, extendJson);
                  v.containerList.map((item) => {
                    if (item.containerType === v.scanGoodsInfo.containerType) {
                      v.scanGoodsInfo.colorCode = item.colorCode;
                    }
                  });
                }
              } else {
                if (v.ymsSkuKeyList.includes(containerType)) {
                  obj = {
                    labelTypeName: labelTypeObj[containerType],
                    primaryImage: item._productInfo.primaryImage,
                    ymsSku: item._productInfo.ymsSku,
                    title: item._productInfo._spuInfo.name,
                    containerType: item.containerType
                  };
                } else {
                  obj = {
                    labelTypeName: labelTypeObj[containerType],
                    primaryImage: item._productInfo.primaryImage,
                    supplierSku: item._productInfo.supplierSku,
                    title: item._productInfo._spuInfo.name,
                    containerType: item.containerType
                  };
                }
                v.scanGoodsInfo = Object.assign({}, obj);
                v.containerList.map((item) => {
                  if (item.containerType === v.scanGoodsInfo.containerType) {
                    v.scanGoodsInfo.colorCode = item.colorCode;
                  }
                });
              }
            }
          });
        }
      }
    },

    // 切换提单号的tab栏
    changeTabs(name, type) {
      let v = this;
      v.sortTab = name;
      /*v.tableData = [];*/
      v.tableColumns = [];
      if (name === 'sku') {
        v.tableColumns = v.skuTableColumns;
        if (v.skuTableData.length > 0) {
          v.$nextTick(() => {
            if (type === 'change') {
              v.tableData = JSON.parse(JSON.stringify(v.skuTableData));
            }
            v.$forceUpdate();
          });
        } else {
          v.tableData = [];
        }
      } else if (name === 'order') {
        v.tableColumns = v.orderTableColumns;
        if (v.orderTableData.length > 0) {
          v.$nextTick(() => {
            if (type === 'change') {
              v.tableData = JSON.parse(JSON.stringify(v.orderTableData));
            }
            v.$forceUpdate();
          });
        } else {
          v.tableData = [];
        }
      }
    },

    // 结束本单分拣
    endSortingOrder(isForceEnd) {
      let v = this;
      let query = {
        isForceEnd: isForceEnd, // 强制结束: 0否 1是
        ymsPickupOrderId: v.ymsPickupOrderId
      };
      v.axios.put(api.put_ymsPickupOrder_closeSorting, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.resetData().then(() => {
            v.getContainerList();
            v.$router.push('/commoditySortingOperation');
            v.$nextTick(() => {
              v.getFocus('scanning');
            });
          });
        }
      });
    },

    // 结束本单分拣按钮
    endSortingOrderBtn(type) {
      let v = this;
      // (云卖面单、无面单)结束本单分拣前，需要检验应发数量和分拣数量
      // (物流面单)结束本单分拣前，需要校验是已经全部扫描
      if (v.skuTableData.length > 0 || v.orderTableData.length > 0) {
        let talg = false;
        // 云卖面单、无面单
        if (v.skuTableData.length > 0) {
          for (let i = 0; i < v.skuTableData.length; i++) {
            let item = v.skuTableData[i];
            // 分拣数量小于应发数量 或者 分拣数量大于应发数量
            if (item.sortingQuantity < item.allQuantity || item.sortingQuantity > item.allQuantity) {
              talg = true;
              break;
            }
          }
          if (talg) {
            v.endType = type;
            v.handleScanningSkuData('finish', {skuData: v.skuTableData, orderData: v.orderTableData});
            return false;
          }
        }
        // 物流面单
        if (v.orderTableData.length > 0) {
          talg = v.orderTableData.every((item) => {
            return item.isScanning === 1;
          });
          if (!talg) {
            v.endType = type;
            v.handleScanningSkuData('finish', {skuData: v.skuTableData, orderData: v.orderTableData});
            return false;
          }
        }
        // 结束提单分拣
        if (type === 'bill') {
          v.endSortingOrder(0);
        }
        // 结束分拣作业
        else if (type === 'sorting') {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004229'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004230'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004231'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001251'),
            onOk: () => {
              v.endSortingFun(0);
            },
            onCancel: () => {
            }
          });
        }
      } else {
        v.$router.push('/commoditySorting');
      }
    },

    // 结束分拣作业
    endSortingFun(isForceEnd) {
      let v = this;
      let query = {
        isForceEnd: isForceEnd, // 强制结束: 0否 1是
        ymsPickupOrderId: v.ymsPickupOrderId
      };
      v.axios.put(api.put_ymsPickupOrder_quitSorting, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.$router.push('/commoditySorting');
        }
      });
    },

    // 绑定上架容器的确定按钮
    shelvingContainer() {
      let obj = {
        code: this.shelvingContainerCode,
        containerType: this.sortingStickerType,
      };
      this.enterScanContainer(obj);
    },

    // 扫描容器编号，绑定容器
    enterScanContainer(item, index) {
      let v = this;
      let query = {
        code: item.code,
        containerType: item.containerType,
        ymsWarehouseId: v.ymsWarehouseId
      };
      if (item.code) {
        if (v.ymsWarehouseId) {
          v.axios.post(api.post_ymsContainerStatus_bindingContainer, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.getContainerList();
              v.scanningSkuModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000559'));
            }
            // 绑定容器的异常提示
            else {
              let code = response.data.code;
              let abnormalCodeList = [
                {code: 1112699, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004232'), content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004233')},
                {code: 1112700, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004234'), content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004235')},
              ];
              for (let i = 0; i < abnormalCodeList.length; i++) {
                let item = abnormalCodeList[i];
                if (code === item.code) {
                  v.$Modal.warning({
                    title: item.title,
                    content: item.content,
                    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
                    onOk: () => {

                    }
                  });
                  return false;
                }
              }
            }
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004236'));
          return false;
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004237'));
        return false;
      }
    },
    // 容器完拣
    containerPickingBtn(data) {
      let v = this;
      v.axios.put(api.put_ymsContainerStatus_closeContainerSorting + `?ymsContainerStatusId=${data.ymsContainerStatusId}`,
        null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.originalContainerList.map((item) => {
            if (item.containerType === data.containerType) {
              item.disabled = false;
              item.code = '';
              item.ymsContainerStatusId = null;
              item.tableData = [];
            }
          });
          v.getContainerList();
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
        }
      });
    },
    // 切换选择容器
    selectContainer(item, index) {
      let v = this;
      v.containerIndex = index;
      if (item.tableData.length <= 0 && item.code === '') {
        v.currentIndex = index;
        v.$nextTick(() => {
          v.getFocus('scanning_' + index);
        });
      }
    },
    // 结束本单分拣成功时，要重置数据
    resetData() {
      let v = this;
      return new Promise((resolve) => {
        v.scanBillDisabled = false;
        v.scanInput = '';
        v.ymsWarehouseId = null;
        v.ymsPickupOrderId = null;
        v.scanSkuDisabled = true;
        v.scanSkuInput = '';
        v.containerList = [];
        v.tableColumns = v.skuTableColumns;
        v.tableData = [];
        v.skuTableData = [];
        v.orderTableData = [];
        v.labelTypeRadioList = [];
        v.labelTypeRadioId = null;
        v.sortTab = 'sku';
        v.containerIndex = 0;
        v.scanGoodsInfo = {};
        v.exceptionPromptTalg = false;
        v.scanningSkuModal = false;
        resolve(true);
      });
    },
    // 扫描SKU异常提示框的确定按钮
    scanAbnormalBtn() {
      let v = this;
      if (v.labelTypeRadioId) {
        let ymsProductGoodsIds = [];
        let billType = '';
        v.labelTypeRadioList.map((item) => {
          item.ymsProductGoodsId = item.businessId;
          ymsProductGoodsIds.push(item.businessId);
          if (item.containerType === v.labelTypeRadioId) {
            if (item.containerType === 'LOGIS_LABEL') {
              billType = 'order';
            } else {
              billType = 'sku';
            }
            v.scanGoodsData(item, billType);
          }
        });
        if (ymsProductGoodsIds.length > 0) {
          let arr = v.uniqueFunc(ymsProductGoodsIds);
          v.getSkuInfo(arr, v.labelTypeRadioId, v.labelTypeRadioList);
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004238'));
        return false;
      }
    },
    // 将光标定位到没有激活的容器
    positionCursor(data) {
      let v = this;
      if (data.length > 0) {
        let talg = data.every((item) => {
          return item.code !== '';
        });
        if (v.scanInput) {
          v.scanSkuDisabled = !talg;
        } else {
          v.scanSkuDisabled = true;
        }
        if (!v.scanSkuDisabled) {
          v.$nextTick(() => {
            v.getFocus('sku_scanning');
          });
        }
        for (let i = 0; i < data.length; i++) {
          let ele = data[i];
          if (ele.code === '') {
            v.$nextTick(() => {
              v.getFocus('scanning_' + i);
            });
            break;
          }
        }
      }
    },

    // 处理扫描sku超出应发数量的商品数据
    handleScanningSkuData(type, data) {
      let v = this;
      v.bingShelfTalg = false;
      // 扫描sku
      if (type === 'scanning') {
        v.scanningSkuTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004239');
        v.alertText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004240');
        v.scanningSkuTableData = [data];
        v.shelvingContainerText = '';
        // 判断当前容器中是否有上架容器
        let keyList = ['CHANGE_SHELVE_LABEL', 'SHELVE_LABEL', 'NONE_LABEL', 'YMS_LABEL'];
        let talg = v.containerList.some((item) => {
          return keyList.includes(item.containerType);
        });
        if (!talg) {
          v.bingShelfTalg = true;
          // 需要贴单
          if (v.sortingStickerType === 'CHANGE_SHELVE_LABEL') {
            v.shelvingContainerText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004241');
          } else {
            v.shelvingContainerText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004242');
          }
        }
      }
      // 结束本单分拣、结束分拣作业
      else {
        v.scanningSkuTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004243');
        v.alertText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004244');
        let newList = [];
        let skuData = data.skuData;
        let orderData = data.orderData;
        if (skuData.length > 0) {
          for (let i = 0; i < skuData.length; i++) {
            let item = skuData[i];
            if (item.sortingQuantity < item.allQuantity || item.sortingQuantity > item.allQuantity) {
              newList.push(item);
            }
          }
          if (newList.length > 0) {
            let list = v.uniqueFunc(newList, 'ymsSku');
            v.scanningSkuTableData = list;
          }
        }
        if (orderData.length > 0) {
          let list = orderData.filter((item) => {
            return item.isScanning !== 1;
          });
          v.scanningOrderTableData = list;
        }
      }
      v.scanningSkuType = type;
      v.scanningSkuModal = true;
    },

    // 监听扫描SKU超量的弹窗
    scanningSkuModalChange(value) {
      if (!value) {
        this.endType = null;
        this.alertText = '';
        this.scanningSkuTitle = '';
        this.scanningSkuType = null;
        this.scanningSkuTableData = [];
        this.shelvingContainerCode = '';
        /**
         * 当关闭超出应发数量的提示框时，如果是暂不处理绑定上架容器时，需要手动剔除分拣数量减一
         * （因为在扫描sku时，当sku需要上架容器的情况下，已经人为的手动添加分拣数量加一）
         */
        if (this.bingShelfTalg) {
          this.scanningSkuModal = false;
          this.scanSkuDisabled = false;
          this.skuTableData.map((item) => {
            if (item.ymsSku === this.originalSkuInput || item.supplierSku === this.originalSkuInput) {
              item.sortingQuantity -= 1;
            }
          });
          this.$forceUpdate();
        }
      }
    },
    // 结束分拣按钮
    endSortBtn() {
      // 结束提单分拣
      if (this.endType === 'bill') {
        this.endSortingOrder(1);
      }
      // 结束分拣作业
      else if (this.endType === 'sorting') {
        this.endSortingFun(1);
      }
    },
    // 获取用户入库分拣的设置
    getConfigurationData(ymsWarehouseId) {
      let v = this;
      v.axios.get(api.get_erpCommonSettingParam_queryPickupParam + ymsWarehouseId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            data.map((item) => {
              item.paramKey = item.paramKey.split(ymsWarehouseId)[0];
              if (item.paramKey === 'fastDeliveryStatus') {
                v.extremeDeliveryMode = Number(item.paramValue);
              }
            });
          }
        }
      });
    },
    // 播放音频
    playAudio(data) {
      let v = this;
      let audioUrl = '';
      v.containerAudio = '';
      // 获取当前容器的音频文件
      v.containerList.map((item) => {
        if (item.containerType === data.containerType) {
          if (item.colorAudioPath) {
            audioUrl = item.colorAudioPath;
            v.containerAudio = audioUrl;
          }
        }
      });
      if (v.broadcast) {
        if (audioUrl) {
          // 极速出库模式下，如果需要贴单，先播放贴单音频，在播放容器音频
          if (v.extremeDeliveryMode) {
            if (data.changeLabel === 1) {
              v.$refs['audioSticker'].setAttribute('src', v.stickerAudio);
              v.$refs['audioSticker'].play();
            } else {
              v.$refs['audioDom'].setAttribute('src', audioUrl);
              v.$refs['audioDom'].play();
            }
          } else {
            v.$refs['audioDom'].setAttribute('src', audioUrl);
            v.$refs['audioDom'].play();
          }
        }
      }
    },
    overAudio() {
      let v = this;
      if (v.containerAudio) {
        v.$refs['audioDom'].setAttribute('src', v.containerAudio);
        v.$refs['audioDom'].play();
      }
    },
    // 极速出库模式下，设置为分拣时进行贴单时，自动操作打印面单
    stickerOperation(skuTableData, value) {
      let v = this;
      v.changeLabel = false;
      if (skuTableData && skuTableData.length > 0) {
        if (v.extremeDeliveryMode) {
          if (v.scanningGoodsObj.changeLabel === 1) {
            v.changeLabel = true;
            let ymsProductGoodsId = skuTableData.filter((item) => {
              return item.ymsSku === value || item.supplierSku === value;
            })[0].ymsProductGoodsId;
            if (ymsProductGoodsId) {
              v.$refs['printPreviewWaybill'].automaticallyPrintWaybill(1, ymsProductGoodsId);
              v.originalSkuInput = '';
            }
          }
        }
      }
    },
    // 撤销扫描记录成功之后，要移除对应已经扫描过的sku或运单号的数据
    undoUpdateData(data) {
      let v = this;
      // 订单
      if (data.trackingNumber !== '--') {
        v.orderTableData.map((item, index) => {
          if (item.trackingNumber === data.trackingNumber) {
            v.$set(v.orderTableData[index], 'isScanning', 0);
            v.$forceUpdate();
          }
        });
        v.tableData.map((item, index) => {
          if (item.trackingNumber === data.trackingNumber) {
            v.$set(v.tableData[index], 'isScanning', 0);
            v.$forceUpdate();
          }
        });
        v.containerList.map((item, index) => {
          if (item.code === data.code) {
            if (item.tableData.length > 0) {
              item.tableData.map((ele, idx) => {
                if (ele.trackingNumber === data.trackingNumber) {
                  item.tableData.splice(idx, 1);
                }
              });
            }
          }
        });
        setTimeout(() => {
          v.changeTabs('order');
          v.containerList = [...v.containerList];
        }, 500);
      }
      // sku
      else {
        v.skuTableData.map((item, index) => {
          if (item.ymsSku === data.ymsSku || item.supplierSku === data.supplierSku) {
            let sortingQuantity = item.sortingQuantity - data.quantity;
            v.$set(v.skuTableData[index], 'sortingQuantity', sortingQuantity);
            v.$forceUpdate();
          }
        });
        v.tableData.map((item, index) => {
          if (item.ymsSku === data.ymsSku || item.supplierSku === data.supplierSku) {
            let quantity = item.sortingQuantity - data.quantity;
            v.$set(v.tableData[index], 'sortingQuantity', quantity);
            v.$forceUpdate();
          }
        });
        v.containerList.map((item, index) => {
          if (item.code === data.code) {
            if (item.tableData.length > 0) {
              item.tableData.map((ele, idx) => {
                if (ele.ymsSku === data.ymsSku || ele.supplierSku === data.supplierSku) {
                  let quantity = ele.quantity - data.quantity;
                  if (quantity > 0) {
                    v.$set(v.containerList[index].tableData[idx], 'quantity', quantity);
                  } else {
                    v.containerList[index].tableData.splice(idx, 1);
                  }
                }
              });
            }
          }
        });
        setTimeout(() => {
          v.changeTabs('sku');
          v.containerList = [...v.containerList];
        }, 500);
      }
    }
  },
  components: {
    printPreviewWaybillModal,
    scanRecordModal
  }
};
</script>

<style lang="less" scoped>
.commodity_sorting_operation_box {
  width: 100%;
  height: 100vh;
  min-width: 1800px;
  background-color: #f5f7f9;
  overflow: auto;

  .scanning_header_box {
    padding: 0 30px;
    height: 60px;
    background-color: #fff;

    .title {
      font-weight: bold;
      font-size: 18px;
      color: #5BB1FF;
    }
  }

  .scanning_box {
    padding: 20px 30px;
    background-color: #fff;

    .input_styles {
      .title {
        color: #333;
        font-weight: bold;
        font-size: 15px;
        margin-bottom: 2px;
      }

      /deep/ .ivu-input-large::-webkit-input-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large:-moz-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large::-moz-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large:-ms-input-placeholder {
        color: #C5C8CE;
        font-size: 15px;
      }

      /deep/ .ivu-input-large {
        height: 44px;
        font-size: 16px;
        color: #666;
      }

      /deep/ .ivu-input-prefix i {
        line-height: 44px;
      }

      /deep/ .ivu-icon-icon-scan:before {
        font-size: 25px;
      }
    }

  }

  .commodity_sorting_content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    min-height: calc(100vh - 70px);

    .scan_bill_box {
      width: 800px;
      min-height: 827px;
      background-color: #fff;
      position: relative;

      /deep/ .ivu-tabs-bar {
        padding: 0 30px;
      }

      /deep/ .ivu-tabs-content {
        padding: 15px 30px 30px 30px;
      }

      .end_sort_order_btn {
        width: 100%;
        padding: 15px 30px;
        box-sizing: border-box;
        border-top: 1px solid #DCDEE2;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }

    .scan_sku_box {
      flex: 1;
      min-height: 827px;
      overflow: hidden;

      .checkbox_styles {
        color: #333;
        position: relative;
        top: 5px;
        font-weight: bold;
        font-size: 17px;
      }

      .scanRecordStyle {

      }

      .scan_content_box {
        width: 100%;
        height: 320px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        background-color: #D7D7D7;
        box-sizing: border-box;
        border-radius: 4px;

        .scan_commodity_title {
          font-size: 28px;
          color: #FF0000;
          font-weight: bold;
        }

        .face_sheet_style {
          color: #000;
          font-size: 24px;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 230px;
          height: 110px;
          border-radius: 4px;
        }

        .sticker_tips_style {
          color: #D8001B;
          font-size: 24px;
          font-weight: bold;
          margin-right: 20px;
        }

        .scan_center_box {
          width: 100%;
          background-color: #fff;
          padding: 15px;
          display: flex;
          justify-content: center;

          .img_styles {
            vertical-align: middle;
            width: auto;
            height: 120px;
            cursor: pointer;
            display: inline-block;
          }

          .text_style_box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 25px 0 25px 15px;

            .text_styles {
              color: #333;
              font-size: 17px;
              font-weight: bold;
            }
          }
        }
      }

      .scan_commodity_styles {
        background-color: #FFC7C0;
        border: 2px solid #D68484;
        justify-content: center;
        align-items: center;
      }

      .container_boxs {
        display: flex;
        /*min-width: 1150px;*/
        overflow-x: auto;
        overflow-y: hidden;

        .container_box_item {
          width: 320px;
          height: 368px;
          border-radius: 4px;
          position: relative;
          background-color: #fff;
          color: #333;
          margin-right: 12px;

          .container_box_title {
            font-size: 17px;
            font-weight: bold;
            padding: 10px 10px 0 10px;
          }

          .add_container_item {
            width: 100%;
            min-width: 320px;
            height: 253px;
            cursor: pointer;
          }

          .add_container_styles {
            width: 320px;
            margin: 0 auto;
            height: 200px;
            background-color: #FFC7C0;
            border: 2px solid #D68484;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            color: #FF0000;
            font-weight: bold;
            box-sizing: border-box;
          }

          .options_box {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 30px;
            box-sizing: border-box;
            border-top: 1px solid #DCDEE2;
          }
        }

        .container_box_item:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .no_classify {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;

    .txt {
      font-size: 15px;
      color: #666;
      margin-top: 15px;
    }
  }
}

/deep/ .scanningSkuModalStyle {
  .shelving_container_box {
    margin-bottom: 10px;

    .title_box {
      margin: 25px 0 5px 0;
      color: #eb1010;
    }
  }
}

</style>
